import type { AppRootState } from 'redux/store'
import { useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'

export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector
